import { render, staticRenderFns } from "./DataRequest.vue?vue&type=template&id=aa0be6e8&scoped=true&"
import script from "./DataRequest.vue?vue&type=script&lang=ts&"
export * from "./DataRequest.vue?vue&type=script&lang=ts&"
import style0 from "./DataRequest.vue?vue&type=style&index=0&id=aa0be6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0be6e8",
  null
  
)

export default component.exports